<template>
    <div class="d-flex flex-column h-full p-3 common-background-color-revamp"
        :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
        <b-row class="d-flex flex-column">
            <b-col>
                <b-card class="card-border-radius common-shadow noborder" body-class="body-landing">
                    <div class="">
                        <b-row class="mt-1 pt-1 pr-2">
                            <b-col class="text-left text-align-self-end">
                                <span style="vertical-align: baseline"
                                    class="font-kanit-bold-16 text-kanit-color-black">ข้อแนะนำการอัปโหลดเอกสารทุกรายการ</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 pt-1 pr-2" v-if="recommentDocList.length > 0">
                            <ul style="display: flex; flex-direction: column;">
                                <li v-for="(item, key) in recommentDocList" :key="key"
                                    style="word-wrap: break-word; white-space: normal">
                                    <h4 class="font-kanit-regular-14 text-kanit-color-black"
                                        style="text-wrap: wrap;display: flex; align-items: center;">
                                        {{ item }}
                                    </h4>
                                </li>
                            </ul>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <template v-if="getDocumentTypeIsRequire().length > 0">
            <b-row class="pt-3"><b-col
                    class="font-kanit-bold-18 text-kanit-color-black">เอกสารประกอบการสมัคร</b-col></b-row>
            <b-row v-for="(item, key) in getDocumentTypeIsRequire()" :key="'require_' + key" class="pt-3">
                <b-col>
                    <b-card class="card-border-radius common-shadow noborder"
                        style="width: 100%; background-color: #ffffff" @click="showExample(item)">
                        <b-row>
                            <b-col class="font-kanit-regular-16-400 text-kanit-color-black">{{
                                item.doc_short_name
                                }}</b-col>
                            <b-col cols="1" class="px-0" style="padding-right: 32px !important"
                                v-b-toggle="'my-collapse-list-account'">
                                <b-icon icon="chevron-right" font-scale="1.2"
                                    style="color: var(--color-primary)" /></b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </template>
        <template v-if="getDocumentTypeIsDeviate().length > 0">
            <b-row class="pt-3"><b-col class="font-kanit-bold-18 text-kanit-color-black">เอกสารเพิ่มโอกาสพิจารณา
                    (ไม่บังคับ)</b-col></b-row>
            <b-row v-for="(item, key) in getDocumentTypeIsDeviate()" :key="'additional_' + key" class="pt-3">
                <b-col>
                    <b-card class="card-border-radius common-shadow noborder"
                        style="width: 100%; background-color: #ffffff" @click="showExample(item)">
                        <b-row>
                            <b-col class="font-kanit-regular-16-400 text-kanit-color-black">{{
                                item.doc_short_name
                                }}</b-col>
                            <b-col cols="1" class="px-0" style="padding-right: 32px !important"
                                v-b-toggle="'my-collapse-list-account'">
                                <b-icon icon="chevron-right" font-scale="1.2"
                                    style="color: var(--color-primary)" /></b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>
<script>
import { exampleDoc } from "@/utils/popup/ExampleDoc.js";
export default {
    data() {
        return {
            documentType: [],
            recommentDocList: [],
        };
    },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
    },
    created() {
        this.$event.$on("onExitCallback", () => this.goToExitEntryPoint());
        const currentMenu = {
            pageCode: "CommonExampleDocTypeGroup",
            pageName: "ตัวอย่างเอกสาร",
            previousPage: "",
        };
        this.$event.$emit("update_current_menu", currentMenu);
        this.documentType = this.userData.documentType;
        this.recommentDocList = [
            "แสดงชื่อ-นามสกุล ต้องตรงกับผู้สมัครสินเชื่อ",
            "แนบภาพถ่ายหรือไฟล์ ที่มีข้อความชัดเจน เอกสารครบทุกหน้า ข้อความครบถ้วนไม่ขาดหาย",
        ];

        const event = {
          action: '',
          category: 'DGL_PT_FollowUpReviewDocUpload_Example',
          label: '',
          value: '',
        };
        if("1115" == this.userData.marketCode && "7002" == this.userData.productType){
          const product = {
            key: "product_type",
            value: "DL_SMARTMONEY"
          }
          const dimension = [product];
          try {
            this.$callback.gaTagging(event, dimension);
          } catch (err) {
            console.error("GA Tagging error", err);
          }
        }

        window.onMobileBackPressed = function () {
            this.$callback.openLfmStatusPage();
            return true;
        };
    },
    beforeDestroy() {
        this.$event.$off("onExitCallback");
    },
    methods: {
        getDocumentTypeIsRequire() {
            return this.documentType.filter((item) => !item.deviate_flag);
        },
        getDocumentTypeIsDeviate() {
            return this.documentType.filter((item) => item.deviate_flag);
        },
        showExample(documentTypeObj) {
            exampleDoc(documentTypeObj.example_doc, this.$swal);
        },
        goToExitEntryPoint() {
            try {
                this.$callback.openLFMProductionShelfWithLoanAppID(
                    this.userData.loanAppId
                );
            } catch (err) {
                console.error(err);
            }
        },
    },
};
</script>
